import React from 'react';

export const ClockTemplate = (props) => {

    const { title, content } = props;

    return (
        <div className="ml-5 d-block text-center">
             <pre className="mr-2">{title}</pre>
            <br />
            <svg viewBox="-5 -5 126 126" style={{ width: "150px" }}>
                <circle
                    className="circle-clock"
                    cx="55" cy="55" r="50"
                    stroke-dasharray="1.71, 30"
                    stroke-width="4"
                />
                <foreignObject x="5" y="5" height="100px" width="100px">
                    <div className="clock-content">{content}</div>
                </foreignObject>
            </svg>
           
        </div>
    );
}


export const CountWidget = (props) => {

    const { title, aboveContent, belowContent } = props;

    return (
        <div className="ml-5 d-block text-center">
            <span>{title}</span>
            <div className="px-3">
                <div style={{ fontSize: "30px", fontWeight: "bold" }}>
                    {aboveContent.content}
                </div>
                <small>{aboveContent.label}</small>
            </div>
            <div className="px-3">
                <div style={{ fontSize: "30px", fontWeight: "bold" }}>
                    {belowContent.content}
                </div>
                <small>{belowContent.label}</small>
            </div>
        </div>
    )
}